import React, { useState, useEffect } from "react";
import axios from "axios";
import ModalSolicitacoesAditivos from "./ModalSolicitacoesAditivos";

function ModalSolicitarAditivo({ projetoId, onClose }) {
  const [tipo, setTipo] = useState("valor");
  const [valor, setValor] = useState("");
  const [prazo, setPrazo] = useState("");
  const [etapa, setEtapa] = useState(null);
  const [descricao, setDescricao] = useState("");
  const [loading, setLoading] = useState(false);
  const [mensagem, setMensagem] = useState("");

  const [secretarias, setSecretarias] = useState([]);
  const [idSecretaria, setIdSecretaria] = useState("");
  const [orcamentos, setOrcamentos] = useState([]);
  const [idOrcamento, setIdOrcamento] = useState("");

  const [showSolicitacoes, setShowSolicitacoes] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("Token");
    axios
      .get("/api/secretaria", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        if (res.data.Status === "Success") setSecretarias(res.data.Result);
        else setMensagem("Erro ao carregar secretarias");
      })
      .catch(() => setMensagem("Erro ao carregar secretarias"));
  }, []);

  useEffect(() => {
    if (!idSecretaria || tipo !== "valor") {
      setOrcamentos([]);
      setIdOrcamento("");
      return;
    }
    const token = localStorage.getItem("Token");
    axios
      .get(`/api/orcamento/secretaria/${idSecretaria}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setOrcamentos(res.data);
        setIdOrcamento(res.data.length > 0 ? String(res.data[0].id) : "");
      })
      .catch(() => {
        setMensagem("Erro ao carregar orçamentos.");
        setOrcamentos([]);
        setIdOrcamento("");
      });
  }, [idSecretaria, tipo]);

  const montarResumo = () => {
    const secretariaNome =
      secretarias.find((sec) => String(sec.id) === idSecretaria)
        ?.nomesecretaria || "";
    const orcamentoDesc =
      orcamentos.find((o) => String(o.id) === idOrcamento)
        ?.classificacao_institucional || "";

    return (
      `Tipo de Aditivo: ${
        tipo === "valor" ? "Aditivo de Valor" : "Aditivo de Prazo"
      }\n` +
      (tipo === "valor"
        ? `Valor a adicionar: R$ ${valor}\nOrçamento: ${orcamentoDesc}\n`
        : `Dias de Prazo: ${prazo}\nEtapa: ${etapa}\n`) +
      `Secretaria: ${secretariaNome}\nJustificativa: ${descricao}\n`
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMensagem("");

    if (!idSecretaria) {
      setMensagem("Selecione uma secretaria.");
      setLoading(false);
      return;
    }
    if (
      tipo === "valor" &&
      (!idOrcamento || valor === "" || isNaN(parseFloat(valor)))
    ) {
      setMensagem("Selecione um orçamento e informe um valor válido.");
      setLoading(false);
      return;
    }
    if (tipo === "prazo") {
      if (prazo === "" || isNaN(parseInt(prazo))) {
        setMensagem("Informe um prazo válido.");
        setLoading(false);
        return;
      }
      if (!etapa) {
        setMensagem("Selecione uma etapa.");
        setLoading(false);
        return;
      }
    }

    try {
      const token = localStorage.getItem("Token");
      const criado_por = parseInt(localStorage.getItem("UserId"), 10);

      const body = {
        id_projeto: projetoId,
        id_secretaria: parseInt(idSecretaria, 10),
        tipo,
        valor: tipo === "valor" ? parseFloat(valor) : null,
        prazo: tipo === "prazo" ? parseInt(prazo, 10) : null,
        descricao_pedido: descricao,
        criado_por,
        etapa: tipo === "prazo" ? etapa : null,
        id_orcamento: tipo === "valor" ? parseInt(idOrcamento, 10) : null,
      };

      await axios.post("/api/aditivos", body, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setMensagem("Solicitação enviada com sucesso!");
      setTimeout(onClose, 1500);
    } catch (error) {
      console.error("Erro ao enviar solicitação:", error);
      setMensagem("Erro ao enviar solicitação.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      role="dialog"
      style={{ background: "#00000099" }}
    >
      <div
        className="modal-dialog modal-dialog-centered modal-xl"
        role="document"
      >
        <form
          className="modal-content rounded-4 shadow-lg border-0 bg-white p-4"
          onSubmit={handleSubmit}
        >
          <div className="modal-header border-0 pb-0 position-relative rounded-top-4 bg-white">
            <h5
              className="modal-title fw-bold text-center w-100"
              style={{ fontSize: "2rem", marginBottom: "2rem" }}
            >
              Solicitar Aditivo
            </h5>
            <button
              type="button"
              className="btn-close position-absolute top-0 end-0 mt-1 me-1"
              onClick={onClose}
              aria-label="Fechar"
            />
          </div>

          <div className="row mt-4">
            <div className="col-md-7">
              <div className="mb-3">
                <label className="form-label fw-semibold">
                  Tipo de Aditivo
                </label>
                <select
                  className="form-select rounded-3"
                  value={tipo}
                  onChange={(e) => setTipo(e.target.value)}
                >
                  <option value="valor">Aditivo de Valor</option>
                  <option value="prazo">Aditivo de Prazo</option>
                </select>
              </div>

              {tipo === "valor" && (
                <>
                  <div className="mb-3">
                    <label className="form-label fw-semibold">
                      Valor a adicionar (R$)
                    </label>
                    <input
                      type="number"
                      className="form-control rounded-3"
                      value={valor}
                      onChange={(e) => setValor(e.target.value)}
                      min="0"
                      step="0.01"
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label fw-semibold">Secretaria</label>
                    <select
                      className="form-select rounded-3"
                      value={idSecretaria}
                      onChange={(e) => setIdSecretaria(e.target.value)}
                      required
                    >
                      <option value="">Selecione a secretaria</option>
                      {secretarias.map((sec) => (
                        <option key={sec.id} value={sec.id}>
                          {sec.nomesecretaria}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="mb-3">
                    <label className="form-label fw-semibold">
                      Justificativa
                    </label>
                    <textarea
                      className="form-control rounded-3"
                      value={descricao}
                      onChange={(e) => setDescricao(e.target.value)}
                      required
                      rows={3}
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label fw-semibold">Orçamento</label>
                    <select
                      className="form-select rounded-3"
                      value={idOrcamento}
                      onChange={(e) => setIdOrcamento(e.target.value)}
                      required
                      disabled={!idSecretaria || orcamentos.length === 0}
                    >
                      {orcamentos.length === 0 ? (
                        <option value="">Nenhum orçamento disponível</option>
                      ) : (
                        orcamentos.map((orc) => (
                          <option key={orc.id} value={orc.id}>
                            {orc.classificacao_institucional} - R${" "}
                            {parseFloat(orc.valor).toLocaleString("pt-BR", {
                              minimumFractionDigits: 2,
                            })}{" "}
                            - {orc.conta_elemento_despesa}
                          </option>
                        ))
                      )}
                    </select>
                  </div>
                </>
              )}

              {tipo === "prazo" && (
                <>
                  <div className="mb-3">
                    <label className="form-label fw-semibold">
                      Dias de Prazo
                    </label>
                    <input
                      type="number"
                      className="form-control rounded-3"
                      value={prazo}
                      onChange={(e) => setPrazo(e.target.value)}
                      min="1"
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label fw-semibold">
                      Etapa a adicionar
                    </label>
                    <select
                      className="form-select rounded-3"
                      value={etapa || ""}
                      onChange={(e) => setEtapa(parseInt(e.target.value, 10))}
                      required
                    >
                      <option value="">Selecione a etapa</option>
                      {[1, 2, 3, 4, 5, 6].map((num) => (
                        <option key={num} value={num}>
                          Etapa {num}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="mb-3">
                    <label className="form-label fw-semibold">Secretaria</label>
                    <select
                      className="form-select rounded-3"
                      value={idSecretaria}
                      onChange={(e) => setIdSecretaria(e.target.value)}
                      required
                    >
                      <option value="">Selecione a secretaria</option>
                      {secretarias.map((sec) => (
                        <option key={sec.id} value={sec.id}>
                          {sec.nomesecretaria}
                        </option>
                      ))}
                    </select>
                  </div>
                </>
              )}
            </div>

            <div className="col-md-5">
              <div className="mb-3">
                <label className="form-label fw-semibold mb-0">
                  Resumo da Solicitação
                </label>
                <textarea
                  className="form-control rounded-3"
                  value={montarResumo() + "\nStatus: Pendente"}
                  readOnly
                  rows={6}
                  style={{
                    minHeight: "120px",
                    maxHeight: "300px",
                    resize: "none",
                    overflowY: "auto",
                  }}
                />
              </div>

              <button
                type="button"
                className="btn btn-info w-100 mb-2"
                onClick={() => setShowSolicitacoes(true)}
              >
                Solicitações
              </button>
            </div>

            {mensagem && (
              <div className="col-12 alert alert-info rounded-3 mb-3">
                {mensagem}
              </div>
            )}

            <div className="col-12 text-start mb-2">
              <button
                type="submit"
                className="btn btn-primary rounded-3 me-2"
                style={{
                  backgroundColor: loading ? "#adb5bd" : "#0d6efd",
                  borderColor: loading ? "#adb5bd" : "#0d6efd",
                  color: "#fff",
                  minWidth: "150px",
                }}
                disabled={loading}
              >
                {loading ? "Enviando..." : "Enviar Solicitação"}
              </button>
              <button
                type="button"
                className="btn btn-secondary rounded-3"
                style={{
                  backgroundColor: "#dc3545",
                  borderColor: "#dc3545",
                  color: "#fff",
                  minWidth: "120px",
                }}
                onClick={onClose}
                disabled={loading}
              >
                Cancelar
              </button>
            </div>
          </div>
        </form>

        {showSolicitacoes && (
          <ModalSolicitacoesAditivos
            projetoId={projetoId}
            onClose={() => setShowSolicitacoes(false)}
          />
        )}
      </div>
    </div>
  );
}

export default ModalSolicitarAditivo;
